import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TruVoiceDomainAuthorization from '../../../../components/tv-domain-authorizations';

class TruVoiceDomainRenderer extends Component {
  render() {
    if (!this.props.data || !this.props.node) {
      return null;
    }
    return (
      <TruVoiceDomainAuthorization
        isModal
        bsSize="xs"
        organization={this.props.data}
      />
    );
  }
}

TruVoiceDomainRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
};
TruVoiceDomainRenderer.defaultProps = {
};

export default TruVoiceDomainRenderer;
